import "./SideNav.css";
import HomeIcon from '@mui/icons-material/Home';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AutoGraph from '@mui/icons-material/AutoGraph';
import { useState, useEffect } from "react";
import { config } from "../../config";
import { useNavigate, Navigate } from "react-router-dom";
import { getString } from "../../lang";

const SideNav = () => {

    const route = useNavigate()

    const [sideNavMenuItems, setSideNavMenuItems] = useState([
        {
            title: "Home",
            link: "home",
            id: 0,
            icon: HomeIcon,
            isSelected: true
        },
        {
            title: "Broker Onboard",
            link: "broker-onboard",
            id: 1,
            icon: AdminPanelSettingsIcon,
            isSelected: false
        },
        {
            title: "Equity",
            link: "equity",
            id: 2,
            icon: AutoGraph,
            isSelected: false
        }
    ]);

    const selectMenuItem = (item) => {
        localStorage.setItem("selected_side_nav_menu_item", item.id);

        let updatedItems = sideNavMenuItems.map((el) => ({
            ...el,
            isSelected: el.id == item.id
        }));

        setSideNavMenuItems(updatedItems);

        route(item.link);
    }

    useEffect(() => {
        const selectedMenuItemId = localStorage.getItem("selected_side_nav_menu_item");

        if(selectedMenuItemId) {
            let updatedItems = sideNavMenuItems.map((el) => ({
                ...el,
                isSelected: el.id == selectedMenuItemId
            }));
            
            setSideNavMenuItems(updatedItems);
        }
    }, [])

    return (
        <div className="side-nav-container">
            <div className="side-nav-logo text-sm">
                { config.company_name }
            </div>

            <div className="side-nav-menu-items">
                {
                    sideNavMenuItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <div className="p-6 cursor-pointer" style={ item.isSelected ? { backgroundColor: 'var(--side-nav-menu-item-selected-color)'} : {}} key={ item.id }>
                                <div className="text-center text-xs" style={ item.isSelected ? { color: '#fff' } : { color: '#7a8495' }  } onClick={() => selectMenuItem(item) }>
                                    <Icon className="menu-item-icon" />

                                    <div className="mt-1">{ getString((item.title).toLowerCase()) }</div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default SideNav;